import SalesListSettingsForm from './SalesListSettingsForm';

function SalesListSettingsModal({
    show,
    allowedPlants,
    plants,
    customers = [],
    initialSettings,
    settings,
    onSave,
    onClose,
    hideCustomers = false,
    title = 'General Settings for Sales',
}) {
    if (!show) {
        return null;
    }

    const resolvedPlants = allowedPlants || plants || [];
    const resolvedSettings = initialSettings || settings;

    return (
        <>
            <div className="modal-backdrop fade show" />
            <div className="modal fade show sales-settings-modal-wrap" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog modal-lg sales-settings-modal-dialog">
                    <div
                        className="modal-content sales-settings-modal"
                        onMouseDown={(event) => event.stopPropagation()}
                    >
                        <div className="modal-body">
                            <h4 className="text font-weight-bold page-title">{title}</h4>
                            <SalesListSettingsForm
                                allowedPlants={resolvedPlants}
                                customers={customers}
                                initialSettings={resolvedSettings}
                                onSave={onSave}
                                onCancel={onClose}
                                showSectionHeader={false}
                                hideCustomers={hideCustomers}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SalesListSettingsModal;
